import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import { propsToDom } from 'core/helpers';
import { Label } from 'styles/typography';
import { ContainerGrid } from 'components/Container';
import { rem } from 'styles/utils';
import { Panel } from 'components/Panel';
import { RichTextEditorial } from 'components/RichText';
import { Reveal } from 'components/Reveal';
import media from 'styles/media';

const EditorialComponent = ({ id, primary, slice_type, next_slice_type, ...others }) => {
  const { background, main_title, text } = primary;
  const hasTitle = !!main_title?.text;
  const hasText = !!text?.richText?.length > 0;

  return (
    <Panel {...propsToDom(others)} id={slice_type} nextId={next_slice_type} background={background}>
      <ContainerGrid>
        <Left>{hasTitle && <Label as="h2">{main_title.text}</Label>}</Left>
        <Right>
          {hasText && (
            <Reveal>
              <RichTextEditorial render={text.richText} />
            </Reveal>
          )}
        </Right>
      </ContainerGrid>
    </Panel>
  );
};

const Left = styled.div`
  grid-column: 1 / span 2;
  padding-top: ${rem(16)};

  ${Label} {
    display: flex;
  }

  ${media.mobile`
    grid-column: 2 / -1;
  `}
`;

const Right = styled.div`
  grid-column: 3 / span 5;

  ${media.mobile`
    grid-column: 2 / -1;
  `}
`;

export const Editorial = styled(EditorialComponent)`
  ${media.mobile`
    ${ContainerGrid} {
      grid-row-gap: calc(var(--margin) * 2);
    }
  `}
`;

export const query = graphql`
  fragment SliceEditorialHome on PrismicHomeDataBodyEditorial {
    id
    slice_type
    primary {
      background
      main_title {
        text
      }
      text {
        richText
      }
    }
  }

  fragment SliceEditorialPage on PrismicPageDataBodyEditorial {
    id
    slice_type
    primary {
      background
      main_title {
        text
      }
      text {
        richText
      }
    }
  }
`;
